export default {
	dashboard: {
	icon: 'dashboard',
		text: 'Dashboard',
		route: 'report.dashboard',
		children: null,
		shortKey: ['q', '1']
},
transactions: {
	icon: 'barcode',
		text: 'Transactions',
		route: null,
		children: {
		live: {
			icon: 'monitor',
				text: 'Transaction',
				route: 'report.transaction.live',
				shortKey: ['q', '2']
		},
		reconciled: {
			icon: null,
				text: 'Reconciliation',
				route: 'report.transaction.reconciled',
				shortKey: ['q', '2']
		},
		reconciled_summary: {
			icon: null,
				text: 'Summary',
				route: 'report.transaction.summary',
				shortKey: ['q', '3']
		},
	},
	shortKey: ['q', '4']
},
mutations: {
	icon: 'fund',
		text: 'Mutations',
		route: 'report.mutation',
		children: null,
		shortKey: ['q', '5']
},
products: {
	icon: 'qrcode',
		text: 'Products',
		route: 'report.product',
		children: null,
		shortKey: ['q', '7']
},
settings: {
	icon: 'setting',
		text: 'Settings',
		route: 'report.setting',
		children: null,
		shortKey: ['q', '6']
}
}
